import { render, staticRenderFns } from "./WorldCongressMemberRegistrationCreate.vue?vue&type=template&id=4bf177ec"
import script from "./WorldCongressMemberRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./WorldCongressMemberRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./WorldCongressMemberRegistrationCreate.vue?vue&type=style&index=0&id=4bf177ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports